import { Model } from '@/services/api/lib'

export default class Store extends Model {
  resource () {
    return 'settings/v1/stores'
  }
}
